export const messages = {
  en: {
    shareReadingFee: {
      search: {
        title: 'Search Conditions',
        roomName: 'Please enter room number',
        ownerName: 'Please enter owner name'
      },
      list: {
        title: 'Shared Reading Fees'
      },
      table: {
        roomName: 'Room',
        ownerName: 'Owner',
        feeName: 'Fee Name',
        degrees: 'Shared Degrees',
        amount: 'Shared Amount',
        remark: 'Remark'
      },
      fetchError: 'Failed to fetch shared reading fees',
      page: {
        title: 'Shared Reading Fees',
        subtitle: 'View shared meter readings and allocated amounts by room',
        empty: 'No shared reading fee records found',
        loadFailed: 'Failed to load shared reading fees, please retry',
        tip: 'Shared readings are derived from the parent meter; amounts are billed to related rooms.'
      }
    }
  },
  zh: {
    shareReadingFee: {
      search: {
        title: '查询条件',
        roomName: '请输入房屋编号',
        ownerName: '请输入业主姓名'
      },
      list: {
        title: '公摊费用'
      },
      table: {
        roomName: '房屋',
        ownerName: '业主',
        feeName: '费用名称',
        degrees: '公摊度数',
        amount: '公摊金额',
        remark: '说明'
      },
      fetchError: '获取公摊费用失败',
      page: {
        title: '公摊费用',
        subtitle: '查看主表公摊度数及分摊至各房屋的公摊金额',
        empty: '暂无公摊费用记录',
        loadFailed: '公摊费用加载失败，请重试',
        tip: '公摊度数由主表抄表记录生成，金额按房屋规则分摊计算。'
      }
    }
  }
}